import { Box, Inline, Stack, Text } from '@/ui';
import type { ReactElement } from 'react';

type MetricSubsectionProps = {
  title: string;
  description?: string;
  headerAccessory?: ReactElement;
  children: ReactElement;
};

export const MetricSubsection = ({
  title,
  description,
  headerAccessory,
  children,
}: MetricSubsectionProps): ReactElement => (
  <Stack gap="md" sx={{ minWidth: 0 }}>
    <Stack gap={description ? 'xxs' : 'none'}>
      <Inline justify="space-between" align="center" wrap="nowrap">
        <Text
          role="body"
          sx={{
            fontSize: (theme) => theme.typography.subtitle1.fontSize,
            lineHeight: (theme) => theme.typography.subtitle1.lineHeight,
            fontWeight: (theme) => theme.typography.subtitle1.fontWeight,
          }}
        >
          {title}
        </Text>
        {headerAccessory ?? <Box />}
      </Inline>
      {description ? (
        <Text role="caption" color="textSecondary">
          {description}
        </Text>
      ) : null}
    </Stack>
    {children}
  </Stack>
);
